export const RegexUtil = {
    address: /^0x(?:[A-Fa-f0-9]{40})$/u,
    transactionHash: /^0x(?:[A-Fa-f0-9]{64})$/u,
    signedMessage: /^0x(?:[A-Fa-f0-9]{130})$/u
};
//# sourceMappingURL=RegexUtil.js.map